<template>
  <div class="ac-body-container">
    <div class="ac-text-wrapper">
      <div v-for="address in shippingAddresses" :key="address.id" class="s-address-container">
        <div class="flex-column">
          <div class="ac-text-header">
            {{ `${address.firstName} ${address.lastName}` }}
          </div>
          <div class="ac-text-body">
            {{ address.address1 }}
          </div>
          <div v-if="address.address2" class="ac-text-body">
            {{ address.address2 }}
          </div>
          <div class="ac-text-body">
            {{ `${address.city}, ${address.state} ${address.zip}` }}
          </div>
        </div>
        <div v-if="adminRole === 'admin'" class="ac-row-container">
          <button @click="editAddress(address)">
            <v-icon color="#4471F1" medium>
              mdi-pencil-outline
            </v-icon>
          </button>
          <!-- <button
            class="ac-button"
            @click="deleteAddress(address)"
          >
            Delete
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

export default {
  name: 'ShippingAddress',
  mixins: [partnerSettingsMixin],
  props: {
    shippingAddresses: Array,
    editAddress: Function,
    deleteAddress: Function,
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}

.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
}

.ac-text-wrapper {
  max-height: 700px;
  flex-wrap: wrap;
  display: flex;
  overflow-y: auto;
}

.ac-text-header {
  font-size: 18px;
  font-weight: 600;
}

.ac-text-body {
  font-size: 18px;
  font-weight: 400;
}
.ac-row-container {
  margin-left: 25px;
  display: flex;
  align-items: center;
}

.ac-button {
  padding: 6px 24px;
  border-radius: 6px;
  color: $WHITE;
  font-weight: 600;
  font-size: 1rem;

  &:first-child {
    background-color: $NBLUE100;
    margin-right: 8px;
  }

  &:last-child {
    background-color: $TOMATO100;
  }
}
</style>
